/**
 * Notify the Flutter WebView app that login succeeded (e.g. so it can send FCM token).
 * Only sends when running inside the app (URL has mv=1).
 */
export function notifyFlutterAppLoginSuccess() {
  if (typeof window === 'undefined') return
  const inWebView = window.location.search.includes('mv=1')
  if (!inWebView) return
  try {
    if (window.MERCHANT_WEP_MESSAGE && typeof window.MERCHANT_WEP_MESSAGE.postMessage === 'function') {
      window.MERCHANT_WEP_MESSAGE.postMessage(JSON.stringify({ action: 'app_login_success' }))
    }
  } catch (e) {
    // ignore
  }
}

/**
 * Ask the Flutter WebView app to send the FCM token to the dashboard (for resubscribe).
 * Only works when running inside the app (URL has mv=1).
 */
export function requestFlutterFcmToken() {
  if (typeof window === 'undefined') return
  const inWebView = window.location.search.includes('mv=1')
  if (!inWebView) return
  try {
    if (window.MERCHANT_WEP_MESSAGE && typeof window.MERCHANT_WEP_MESSAGE.postMessage === 'function') {
      window.MERCHANT_WEP_MESSAGE.postMessage(JSON.stringify({ action: 'request_fcm_token' }))
    }
  } catch (e) {
    // ignore
  }
}

export function isInFlutterWebView() {
  if (typeof window === 'undefined') return false
  return window.location.search.includes('mv=1')
}

/**
 * In Flutter WebView, client-side router.push may not update the displayed page.
 * Use full page redirect to home so the WebView actually navigates.
 * @param {import('vue-router').default} router - Vue Router instance (e.g. this.$router)
 * @returns {boolean} true if redirect was performed, false otherwise
 */
export function redirectToHomeIfInWebView(router) {
  if (typeof window === 'undefined' || !router) return false
  if (!window.location.search.includes('mv=1')) return false
  try {
    const resolved = router.resolve({ name: 'owner:home', query: { mv: '1' } })
    if (resolved && resolved.href) {
      window.location.href = resolved.href
      return true
    }
  } catch (e) {
    // ignore
  }
  return false
}
